import React from 'react';

import { SiteFooter } from '../../components/SiteFooter/SiteFooter';
import { HeroSection } from './HeroSection';
import { AthleteCarousel } from './AthleteCarousel';
import { FeaturedBrands } from './FeaturedBrands';
import { JoinSection } from './JoinSection';
import type { Athlete } from './athletes';
import type { Brand } from './brands';
import type { HeroRotationItem } from './heroRotation';
import type { JoinSectionData } from './joinSectionData';

type SplashProps = {
    csrfToken: string;
    heroRotation: HeroRotationItem[];
    athletes: Athlete[];
    brandGrid: Brand[][];
    featuredHeading: string;
    featuredBody: string;
    joinSection: JoinSectionData;
};

export function Splash({
    csrfToken,
    heroRotation,
    athletes,
    brandGrid,
    featuredHeading,
    featuredBody,
    joinSection,
}: SplashProps) {
    return (
        <div className="splash">
            <HeroSection heroRotation={heroRotation} />
            {athletes.length > 0 && <AthleteCarousel athletes={athletes} />}
            <FeaturedBrands brandGrid={brandGrid} heading={featuredHeading} body={featuredBody} />
            <JoinSection data={joinSection} />
            <SiteFooter csrfToken={csrfToken} />
        </div>
    );
}
